// src/pages/Shop.js
import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ShopContext } from "../context/shop-context";
import Carousel from "react-material-ui-carousel";
// import SaleBanner from "../components/SaleBanner";

const Shop = () => {
  const { addItemToCart, cartItems } = useContext(ShopContext);

  // State for handling modal visibility and selected item
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // const calculateDiscountedPrice = (price) => {
  //   const numericPrice = parseFloat(price.replace("ksh", "").replace(",", ""));
  //   const discountedPrice = numericPrice * 0.8; // Apply 30% discount
  //   return `ksh ${discountedPrice.toFixed(2)}`;
  // };

  // Categories for each season
  const categories = [
    {
      season: "Winter Collection",
      items: [
        {
          id: 1,
          name: "Hexagon Cardigan",
          price: "ksh 4000.00",
          image: "/hexagon.jpeg",
          relatedImages: ["/hexagon.jpeg", "/hexagon1.jpeg"],
        },
        {
          id: 2,
          name: "Cable Sweater",
          price: "ksh 4500.00",
          image: "cable.webp",
          relatedImages: [
            "cable1.webp",
            "https://i.etsystatic.com/18940880/r/il/1ecb85/3820768801/il_794xN.3820768801_ks9v.jpg",
            "https://i.etsystatic.com/18940880/r/il/ec6fba/3773172684/il_794xN.3773172684_jx7i.jpg",
          ],
        },
        {
          id: 3,
          name: "Balloon Sleeve Cardigan",
          price: "ksh 4500.00",
          image:
            "https://i.etsystatic.com/18940880/r/il/fbd96d/3630733309/il_794xN.3630733309_q5t7.jpg",
          relatedImages: [
            "Balloon.avif",
            "https://i.etsystatic.com/18940880/r/il/b1991f/3583117168/il_794xN.3583117168_gnd0.jpg",
            "https://i.etsystatic.com/18940880/r/il/17fde8/3583117174/il_794xN.3583117174_agpg.jpg",
          ],
        },
        {
          id: 16,
          name: "Ribbed Beanie",
          price: "ksh 1200.00",
          image: "beanie.jpeg",
          relatedImages: [
            "beanie.jpeg",
            "https://i.etsystatic.com/23107998/r/il/4b3f43/4422752532/il_794xN.4422752532_f9k5.jpg",
            "https://i.etsystatic.com/23107998/r/il/7c79c2/4470108437/il_794xN.4470108437_mwt3.jpg",
          ],
        },
      ],
    },
    {
      season: "Summer Collection",
      items: [
        {
          id: 4,
          name: "Shorts",
          price: "ksh 1500.00",
          image: "/shorts.jpg",
          relatedImages: [
            "shorts.jpg",
            "https://i.etsystatic.com/47890228/r/il/340895/5900442878/il_794xN.5900442878_t8n9.jpg",
            "https://i.etsystatic.com/47890228/r/il/18bd09/5764626450/il_794xN.5764626450_cafo.jpg",
          ],
        },
        {
          id: 5,
          name: "Bucket Hat",
          price: "ksh 1500.00",
          image:
            "https://i.etsystatic.com/35739036/r/il/b035af/3879159118/il_794xN.3879159118_l2t0.jpg",
          relatedImages: [
            "BucketHat.webp",
            "https://i.etsystatic.com/37287496/r/il/dd3e6f/4833839824/il_794xN.4833839824_q98q.jpg",
            "https://i.etsystatic.com/35739036/r/il/b035af/3879159118/il_794xN.3879159118_l2t0.jpg",
          ],
        },
        {
          id: 6,
          name: "Ruffle Hat",
          price: "ksh 2500.00",
          image:
            "https://i.etsystatic.com/35241152/r/il/a89103/5662350872/il_794xN.5662350872_qfk5.jpg",
          relatedImages: [
            "https://i.etsystatic.com/35241152/r/il/a89103/5662350872/il_794xN.5662350872_qfk5.jpg",
            "https://i.etsystatic.com/35241152/r/il/821fd4/5710402573/il_794xN.5710402573_mjgu.jpg",
            "https://i.etsystatic.com/35241152/r/il/1faaed/5710402681/il_794xN.5710402681_ohyr.jpg",
          ],
        },
        {
          id: 15,
          name: "Tank Top",
          price: "ksh 1500.00",
          image:
            "https://i.etsystatic.com/34201462/r/il/213f95/3796292139/il_794xN.3796292139_n92j.jpg",
          relatedImages: [
            "https://i.etsystatic.com/34201462/r/il/213f95/3796292139/il_794xN.3796292139_n92j.jpg",
            "https://i.etsystatic.com/34201462/r/il/a6975e/3796292541/il_794xN.3796292541_kgvh.jpg",
            "https://i.etsystatic.com/34201462/r/il/ccc86c/3748700822/il_794xN.3748700822_hqey.jpg",
          ],
        },
      ],
    },
    {
      season: "Spring Collection",
      items: [
        {
          id: 7,
          name: "Rose Bag",
          price: "ksh 6000.00",
          image: "/rosebag.jpg",
          relatedImages: [
            "/rosebag.jpg",
            "https://i.etsystatic.com/36755599/r/il/dbaa47/6242867449/il_794xN.6242867449_5pxb.jpg",
            "https://i.etsystatic.com/36755599/r/il/e4a0bd/6242864821/il_794xN.6242864821_bpns.jpg",
          ],
        },
        {
          id: 8,
          name: "Canva Bag",
          price: "ksh 4500.00",
          image: "/canvabag.jpg",
          relatedImages: [
            "/canvabag.jpg",
            "https://i.etsystatic.com/26585403/r/il/168396/2777279248/il_794xN.2777279248_iwya.jpg",
            "https://i.etsystatic.com/26585403/r/il/5d97b8/3929331341/il_794xN.3929331341_og8c.jpg",
          ],
        },
        {
          id: 9,
          name: "Rose Flower",
          price: "ksh 300.00",
          image: "/rose.jpg",
          relatedImages: [
            "/rose.jpg",
            "https://i.etsystatic.com/53456136/r/il/edab2b/6482781267/il_794xN.6482781267_9a6i.jpg",
            "https://i.etsystatic.com/53456136/r/il/95f7e9/6482781253/il_794xN.6482781253_8blr.jpg",
          ],
        },
        {
          id: 17,
          name: "Tulip Key Chain",
          price: "ksh 300.00",
          image: "/tulip.jpg",
          relatedImages: [
            "/tulip.jpg",
            "https://i.etsystatic.com/49162195/r/il/b2bb0f/6026455287/il_794xN.6026455287_9g38.jpg",
            "https://i.etsystatic.com/49162195/r/il/6918e7/6026452743/il_794xN.6026452743_onj7.jpg",
          ],
        },
      ],
    },
    {
      season: "Autumn Collection",
      items: [
        {
          id: 10,
          name: "Baby Socks and Hat",
          price: "ksh 800.00",
          image: "/baby.jpg",
          relatedImages: [
            "/baby.jpg",
            "https://i.etsystatic.com/35786856/r/il/69ce5d/4511865958/il_794xN.4511865958_rmel.jpg",
            "https://i.etsystatic.com/19286365/r/il/34d48d/1950145918/il_794xN.1950145918_c5ec.jpg",
          ],
        },
        {
          id: 11,
          name: "Scarf",
          price: "ksh 2000.00",
          image: "/scarf.jpg",
          relatedImages: [
            "scarf.jpg",
            "https://i.etsystatic.com/20390955/r/il/533c78/2468039171/il_794xN.2468039171_se51.jpg",
            "https://i.etsystatic.com/8271146/r/il/77ec5c/2740901724/il_794xN.2740901724_ijvh.jpg",
          ],
        },
        {
          id: 12,
          name: "Cocoon Cardigan",
          price: "ksh 3000.00",
          image: "/cocoon.jpg",
          relatedImages: [
            "/cocoon.jpg",
            "https://i.etsystatic.com/36030649/r/il/c8c43c/5249408262/il_794xN.5249408262_11ou.jpg",
            "https://i.etsystatic.com/36030649/r/il/f5b961/5249408266/il_794xN.5249408266_hdgp.jpg",
          ],
        },
        {
          id: 13,
          name: "Pocket Shawl",
          price: "ksh 3500.00",
          image: "/shawl.jpeg",
          relatedImages: [
            "/shawl.jpeg",
            "https://i.etsystatic.com/7872373/r/il/6b84c3/4202001337/il_794xN.4202001337_qliv.jpg",
            "https://i.etsystatic.com/7872373/r/il/64e94d/3434532608/il_794xN.3434532608_3avk.jpg",
          ],
        },
      ],
    },
  ];

  // Handle modal open/close
  const handleOpen = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedItem(null);
    setOpen(false);
  };

  return (
    <Box sx={{ padding: "2rem" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Get to buy our amazing Products
      </Typography>

      {/* Display all categories (seasons) and their items */}
      {categories.map((category, index) => (
        <Box key={index} sx={{ marginBottom: "2rem" }}>
          <Typography variant="h5" gutterBottom>
            {category.season}
          </Typography>
          <Grid container spacing={3}>
            {category.items.map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item.id}>
                <Card sx={{ maxWidth: 345, margin: "auto" }}>
                  <CardMedia
                    component="img"
                    height="300"
                    image={item.image}
                    alt={item.name}
                    sx={{ objectFit: "cover", cursor: "pointer" }}
                    onClick={() => handleOpen(item)} // Open modal on click
                  />
                  <CardContent>
                    <Typography variant="h6">{item.name}</Typography>
                    <Typography variant="body2">{item.price}</Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => addItemToCart(item)}
                      sx={{
                        margin: "1rem",
                        backgroundColor: "#16014f",
                        "&:hover": { backgroundColor: "#d75efb" },
                      }}
                    >
                      Add To Cart
                      {cartItems[item.id]
                        ? `(${cartItems[item.id].quantity})`
                        : ""}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}

      {/* Popup Dialog for image preview */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent>
          <Box position="relative">
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 1,
                color: "white",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <CloseIcon />
            </IconButton>
            {selectedItem && (
              <Carousel>
                {selectedItem.relatedImages.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`${selectedItem.name} - ${idx + 1}`}
                    style={{ width: "100%", height: "auto" }}
                  />
                ))}
              </Carousel>
            )}
          </Box>
          {selectedItem && (
            <Box mt={2}>
              <Typography variant="h6" gutterBottom>
                {selectedItem.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {selectedItem.price}
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Shop;
